import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "reactstrap";
import { toast } from "../../../core/helpers/message-helper";
import { asignarPermiso, obtenerPermisos } from '../../../modules/Permisos/services/permisos-service';

const PermisosCheck = ({ valor, modificarPermiso, permiso, grupoId }) => {
    const [checkeado, setCheckeado] = useState(valor);

    useEffect(() => setCheckeado(valor), [valor]);

    function seleccionPermiso() {
        setCheckeado(!checkeado);
        modificarPermiso(permiso, !checkeado, grupoId);
    }

    return (
        <input
            style={{
                display: "inline-block",
                width: "11%",
                height: "1.2875rem",
            }}
            type="checkbox"
            checked={checkeado}
            onChange={seleccionPermiso}
        />
    );
};

PermisosCheck.propTypes = {
    valor: PropTypes.bool,
    modificarPermiso: PropTypes.func,
    permiso: PropTypes.object,
    grupoId: PropTypes.string
}

const GruposCheck = ({ valor, modificarGrupo, grupoId }) => {
    const [checkeado, setCheckeado] = useState(valor);

    useEffect(() => setCheckeado(valor), [valor]);

    function seleccionPermiso() {
        setCheckeado(!checkeado);
        modificarGrupo(grupoId, !checkeado);
    }

    return (
        <input
            style={{
                display: "inline-block",
                width: "3%",
                height: "1.3875rem",
            }}
            type="checkbox"
            checked={checkeado}
            onChange={seleccionPermiso}
        />
    );
};

GruposCheck.propTypes = {
    valor: PropTypes.bool,
    modificarGrupo: PropTypes.func,
    grupoId: PropTypes.string
}

const AdministradorPermisos = ({
    idPersona,
    cancelarAsignacion,
    asignacionCompletada,
}) => {
    const [grupos, setGrupos] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [permisos, setPermisos] = useState({
        permisosActuales: [],
        crearPermisos: [],
        eliminarPermisos: [],
    });

    async function guardarAsignacionPermisos() {
        setCargando(true);
        const resp = await asignarPermiso(
            idPersona,
            permisos.crearPermisos,
            permisos.eliminarPermisos
        );
        setCargando(false);

        if (!resp.status) {
            return toast.error(resp.message);
        }

        toast.success(resp.message);
        asignacionCompletada();
    }

    function modificarGrupo(grupoId, valor) {
        const { crearPermisos, eliminarPermisos } = permisos;
        const grupo = grupos.find((grupo) => {
            return grupo.id_grupo == grupoId;
        });

        grupo.activo = valor == true ? 1 : 0;
        grupo.permisos.forEach((permiso) => {
            const accion = gestionarPermiso(permiso, valor);

            if (accion == "crearPermiso") {
                permiso.activo = 1;
                if (!crearPermisos.includes(permiso.codigo)) {
                    crearPermisos.push(permiso.codigo);
                }
            } else if (accion == "eliminarPermiso") {
                permiso.activo = 0;
                if (!eliminarPermisos.includes(permiso.codigo)) {
                    eliminarPermisos.push(permiso.codigo);
                }
            } else if (accion == "descartarPermisoAgregado") {
                permiso.activo = 0;
                const index = crearPermisos.findIndex(
                    (permisoCreado) => permisoCreado == permiso.codigo
                );

                crearPermisos.splice(index, 1);
            } else {
                permiso.activo = 1;
                const index = eliminarPermisos.findIndex(
                    (permisoEliminar) => permisoEliminar == permiso.codigo
                );

                eliminarPermisos.splice(index, 1);
            }
        });

        setPermisos((grupos) => {
            return { ...grupos, crearPermisos, eliminarPermisos };
        });
    }

    function modificarPermiso(permiso, valor, grupoId) {
        const accion = gestionarPermiso(permiso, valor);
        const grupo = grupos.find((gru) => gru.id_grupo == grupoId);
        grupo.permisos.forEach((per) => {
            if (per.id == permiso.id) {
                per.activo = valor == true ? 1 : 0;
            }
        });
        grupo.activo = !grupo.permisos.some((per) => per.activo != 1);

        if (accion == "crearPermiso") {
            setPermisos((permisos) => ({
                ...permisos,
                crearPermisos: [...permisos.crearPermisos, permiso.codigo],
            }));
        } else if (accion == "eliminarPermiso") {
            setPermisos((permisos) => ({
                ...permisos,
                eliminarPermisos: [
                    ...permisos.eliminarPermisos,
                    permiso.codigo,
                ],
            }));
        } else if (accion == "descartarPermisoAgregado") {
            setPermisos((permisos) => {
                const crearPermisos = borrarPermisoDeArray(
                    permisos.crearPermisos,
                    permiso
                );
                return { ...permisos, crearPermisos };
            });
        } else {
            setPermisos((permisos) => {
                const eliminarPermisos = borrarPermisoDeArray(
                    permisos.eliminarPermisos,
                    permiso
                );
                return { ...permisos, eliminarPermisos };
            });
        }
    }

    function borrarPermisoDeArray(arrayPermisos, permiso) {
        const index = arrayPermisos.findIndex(
            (permisoCreado) => permisoCreado == permiso.codigo
        );

        arrayPermisos.splice(index, 1);
        return arrayPermisos;
    }

    function gestionarPermiso(permiso, valor) {
        const existePermiso = permisos.permisosActuales.find(
            (permisoActual) => permisoActual.id == permiso.id
        );

        const existePermisoCrear = permisos.crearPermisos.find(
            (permisoCrear) => permisoCrear.id == permiso.id
        );

        if (valor && !existePermiso) {
            return "crearPermiso";
        } else if (valor && existePermiso && !existePermisoCrear) {
            return "marcarPermiso";
        } else if (!valor && existePermiso) {
            return "eliminarPermiso";
        } else if (!valor && !existePermiso) {
            return "descartarPermisoAgregado";
        }
    }

    useEffect(async () => {
        if (idPersona == null) return;

        const resp = await obtenerPermisos(idPersona);
        if (!resp.status) return toast.error(resp.message);

        const permisosActuales = resp.data.map((grupo) =>
            grupo.permisos.filter((permiso) => permiso.activo == 1)
        );

        resp.data.forEach((grupo) => {
            grupo.activo = !grupo.permisos.some(
                (permiso) => permiso.activo != 1
            );
        });

        setGrupos(resp.data);
        setPermisos((permisos) => ({
            ...permisos,
            permisosActuales: permisosActuales.flat(),
        }));
    }, [idPersona]);

    return (
        <>
            <div>
                {grupos.map((grupo) => {
                    return (
                        <div key={grupo.id_grupo} className="mb-3">
                            <GruposCheck
                                grupoId={grupo.id_grupo}
                                valor={grupo.activo == 1}
                                modificarGrupo={modificarGrupo}
                            />
                            <h4 className="d-inline-block ml-2">
                                {grupo.nombre_grupo}
                            </h4>
                            <Row className="pl-4">
                                {grupo.permisos.map((permiso) => {
                                    return (
                                        <Col
                                            md={4}
                                            key={`${grupo.id_grupo}-${permiso.id}`}
                                        >
                                            <div>
                                                <PermisosCheck
                                                    grupoId={grupo.id_grupo}
                                                    valor={permiso.activo == 1}
                                                    modificarPermiso={
                                                        modificarPermiso
                                                    }
                                                    permiso={permiso}
                                                />
                                                <span className="ml-2">
                                                    {permiso.nombre}
                                                </span>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    );
                })}
            </div>
            <div className="d-flex justify-content-end">
                <Button
                    className="mr-2"
                    color="secondary"
                    key="save"
                    type="submit"
                    disabled={cargando}
                    onClick={guardarAsignacionPermisos}
                >
                    {cargando ? (
                        <Spinner size="sm" />
                    ) : (
                        <i className="fas fa-plus mr-2"></i>
                    )}
                    <span>Guardar</span>
                </Button>
                <Button
                    color="primary"
                    key="close"
                    onClick={() => cancelarAsignacion()}
                >
                    <i className="fas fa-trash mr-2"></i>
                    Cancelar
                </Button>
            </div>
        </>
    );
};

AdministradorPermisos.propTypes = {
    asignacionCompletada: PropTypes.func,
    cancelarAsignacion: PropTypes.func,
    idPersona: PropTypes.string
}

export default AdministradorPermisos;
